import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CurrencyFormatterPipe, DateTimePipe, DurationPipe, FilterPipe, FilterUniquePipe, OrderByPipe, SafeHtml, TaskListFilter, TechnicalTranslatePipe, 
          MMSClientDataPipe, SpellCheckPipe, MMSTranslatePipe, FormatRiskAssessmentPipe } from './index';
import { ArrayManipulationsPipe } from './arrayManipulations/array-manipulations.pipe';
import { FilterSortGridDataPipe } from './filterSortGridData/filter-sort-grid-data.pipe';

export const customPipes: any = [CurrencyFormatterPipe, DateTimePipe, DurationPipe, FilterPipe,
  FilterUniquePipe, OrderByPipe, SafeHtml, TaskListFilter, TechnicalTranslatePipe,
  MMSClientDataPipe, ArrayManipulationsPipe, SpellCheckPipe, MMSTranslatePipe, FilterSortGridDataPipe, FormatRiskAssessmentPipe ]

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [...customPipes],
  exports: [...customPipes]
})
export class CustomPipesModule {
}
